import Spinner from "../../Spinner";
import { Button } from "./style";

interface Options {
  type: "filled" | "outline" | "link";
  size: "xs" | "sm" | "md" | "lg" | "xl";
  skin: "primary" | "secondary" | "gray" | "transparent" | "white" | "danger";
  block?: boolean;
  marginBottom?: string;
}

const defaultOptions: Options = {
  skin: "primary",
  size: "lg",
  type: "filled",
  block: false,
  marginBottom: "0px",
};

interface ComponentProps {
  isSubmmiting: boolean;
  type?: "submit" | "button";
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  options?: Options;
  form: string;
  children: any;
  style?: any;
  color?: string;
}

const Component = ({
  isSubmmiting,
  children,
  options,
  type = "submit",
  ...rest
}: ComponentProps) => {
  return (
    <Button
      options={{
        ...defaultOptions,
        ...options,
      }}
      type={type}
      disabled={isSubmmiting}
      {...rest}
    >
      {isSubmmiting ? <Spinner /> : children}
    </Button>
  );
};

export default Component;
